/**
 * Catálogo de permissões da equipe (RBAC, plano §5.4). Um perfil é um conjunto destas strings.
 * O painel usa este catálogo para montar a tela de perfis; a API usa nos guards.
 */
export const PERMISSOES = {
    // Atendimento
    'conversas.atender': 'Atender conversas dos seus setores',
    'conversas.transferir': 'Transferir conversas',
    'conversas.encerrar': 'Encerrar conversas',
    'conversas.ver_setor': 'Ver todas as conversas do setor (monitor)',
    'conversas.intervir': 'Assumir, sussurrar e redistribuir conversas do setor',
    'conversas.solicitar_verificacao': 'Solicitar verificação de identidade no chat',
    'clientes.ver': 'Ver dados do cliente (conforme visibilidade de campos do perfil)',
    'clientes.exportar': 'Exportar dados de cliente',
    // Gestão
    'setores.gerir': 'Criar/editar setores, horários e limites',
    'usuarios.gerir': 'Criar/editar usuários da equipe',
    'perfis.gerir': 'Criar/editar perfis e permissões',
    'fluxos.editar': 'Editar fluxos (rascunho)',
    'fluxos.publicar': 'Publicar versões de fluxo',
    'mensagens_rapidas.gerir': 'Gerir mensagens rápidas e tags',
    'configuracoes.gerir': 'Alterar configurações do sistema',
    // Relatórios / LGPD
    'relatorios.setor': 'Relatórios dos seus setores',
    'relatorios.global': 'Relatórios de todos os setores',
    'auditoria.ver': 'Consultar trilha de auditoria',
    'lgpd.solicitacoes': 'Tratar solicitações de titulares (LGPD)',
};
export const TODAS_PERMISSOES = Object.keys(PERMISSOES);
/**
 * Permissões que abrem alguma tela além do atendimento em si. Quem não tem nenhuma
 * delas só atende — e ganha a estação de trabalho em tela cheia, sem menu lateral,
 * porque não há para onde navegar.
 */
export const PERMISSOES_DE_GESTAO = [
    'conversas.ver_setor',
    'conversas.intervir',
    'clientes.exportar',
    'setores.gerir',
    'usuarios.gerir',
    'perfis.gerir',
    'fluxos.editar',
    'fluxos.publicar',
    'mensagens_rapidas.gerir',
    'configuracoes.gerir',
    'relatorios.setor',
    'relatorios.global',
    'auditoria.ver',
    'lgpd.solicitacoes',
];
/**
 * Este perfil só atende (não supervisiona, não administra)?
 *
 * Aceita qualquer coisa e não confia no tipo. As permissões vêm de uma coluna JSON, e um
 * perfil gravado com `{}` ou `null` no lugar da lista fazia o `.some` estourar no primeiro
 * render do painel — tela preta, sem mensagem, antes mesmo de qualquer chamada à API.
 * Dado torto no banco não pode derrubar a tela de quem só queria trabalhar.
 */
export function soAtende(permissoes) {
    if (!Array.isArray(permissoes))
        return true;
    return !permissoes.some((p) => PERMISSOES_DE_GESTAO.includes(p));
}
/** Conjuntos dos perfis base criados pelo seed (editáveis pelo admin depois). */
export const PERMISSOES_PERFIS_BASE = {
    Admin: TODAS_PERMISSOES,
    Supervisor: [
        'conversas.atender',
        'conversas.transferir',
        'conversas.encerrar',
        'conversas.ver_setor',
        'conversas.intervir',
        'conversas.solicitar_verificacao',
        'clientes.ver',
        'mensagens_rapidas.gerir',
        'relatorios.setor',
    ],
    Atendente: [
        'conversas.atender',
        'conversas.transferir',
        'conversas.encerrar',
        'conversas.solicitar_verificacao',
        'clientes.ver',
    ],
};
//# sourceMappingURL=permissoes.js.map